import {getData} from './GetData';

const SuggestionService = (value) => {
  const apiGatewayUrl = process.env.RAZZLE_API_GATEWAY_URL || window.env.RAZZLE_API_GATEWAY_URL;
  return getData({url: `${apiGatewayUrl}/suggestions?words=${value}&size=25`});
};

export default SuggestionService;
